import { useParams, useLocation, Navigate } from "react-router-dom";
import { APP_ROUTES } from "./appRoutes";

/**
 * Handles legacy /{slug} URLs by redirecting to /ch/{slug}
 * Also handles numeric channel IDs (e.g., /60 -> /ch/60)
 * The GalleryPage component will handle ID->slug resolution
 *
 * IMPORTANT: Preserves query strings and hash fragments for analytics tracking
 */
const LegacyChannelRedirect = () => {
  const { slug } = useParams();
  const location = useLocation();

  // Don't redirect known app paths to /ch/ — send to root instead.
  // For unauthenticated users (the only case that reaches here), / → /sign-in.
  if (APP_ROUTES.has(slug)) {
    return <Navigate to="/" replace />;
  }

  // Redirect to the canonical /ch/{slug} URL, preserving query params and hash
  return (
    <Navigate to={`/ch/${slug}${location.search}${location.hash || ""}`} replace />
  );
};

export default LegacyChannelRedirect;
